// extracted by mini-css-extract-plugin
export default {"btnIcon_circle":"c-a_cv"};